import $ from 'jquery';

/**
 * RightBar
 */
export default class RightBar {

	/**
	 * @param {import('./app').default} app
	 */
	constructor(app) {
		this.body = $('body');
		this.window = $(window);
		this.app = app;
	}

	/**
	 * Select the option based on saved config
	 */
	_selectOptionsFromConfig() {

		const config = this.app.getLayoutConfig();

		if (config) {
			// sideBarTheme
			$('.end-bar input[type=checkbox]').prop('checked', false);

			switch (config.sideBarTheme) {
				case 'default':
					$('#default-check').prop('checked', true);
					break;
				case 'light':
					$('#light-check').prop('checked', true);
					break;
				case 'dark':
					$('#dark-check').prop('checked', true);
					break;
			}

			if (config.isBoxed) {
				$('#boxed-check').prop('checked', true);
			}
			else {
				$('#fluid-check').prop('checked', true);
			}
			if (config.isCondensed) {
				$('#condensed-check').prop('checked', true);
			}
			if (config.isScrollable) {
				$('#scrollable-check').prop('checked', true);
			}
			if (!config.isScrollable && !config.isCondensed) {
				$('#fixed-check').prop('checked', true);
			}

			// overall color scheme
			if (!config.isDarkModeEnabled) {
				$('#light-mode-check').prop('checked', true);
				if (config.layout === 'vertical') {
					$('input[type=checkbox][name=theme]').prop('disabled', false);
				}
			}
			if (config.isDarkModeEnabled) {
				$('#dark-mode-check').prop('checked', true);
				if (config.layout === 'vertical') {
					$('input[type=checkbox][name=theme]').prop('disabled', false);
				}
			}
		}
	}
	/**
	 * Toggles the right sidebar
	 */
	toggleRightSideBar() {
		this.body.toggleClass('end-bar-enabled');
		this._selectOptionsFromConfig();
	}
	/**
	 * Initilizes the right side bar
	 */
	init() {

		const that = this;

		if (document.body.getAttribute('data-rightbar-onstart') === 'true') {
			if (!localStorage.getItem('_HYPER_VISITED')) {
				localStorage.setItem('_HYPER_VISITED', 'true');
				that.toggleRightSideBar();
			}
		}

		// right side-bar toggle
		$(document).on('click', '.end-bar-toggle', () => {
			that.toggleRightSideBar();
		});

		$(document).on('click', 'body', (e) => {

			if ($(e.target).closest('.end-bar-toggle, .end-bar').length > 0) {
				return;
			}
			if ($(e.target).closest('.leftside-menu, .side-nav').length > 0 || $(e.target).hasClass('button-menu-mobile') || $(e.target).closest('.button-menu-mobile').length > 0) {
				return;
			}

			$('body').removeClass('end-bar-enabled');
			$('body').removeClass('sidebar-enable');
		});

		// width mode
		$('input[type=checkbox][name=width]').on('change', function() {

			switch ($(this).val()) {
				case 'fluid':
					that.app.activateFluid();
					break;
				case 'boxed':
					that.app.activateBoxed();
					break;
			}

			that._selectOptionsFromConfig();
		});

		// theme
		$('input[type=checkbox][name=theme]').on('change', function() {

			switch ($(this).val()) {
				case 'default':
					that.app.activateDefaultSidebarTheme();
					break;
				case 'light':
					that.app.activateLightSidebarTheme();
					break;
				case 'dark':
					that.app.activateDarkSidebarTheme();
					break;
			}

			that._selectOptionsFromConfig();
		});

		// compact
		$('input[type=checkbox][name=compact]').on('change', function() {

			switch ($(this).val()) {
				case 'fixed':
					that.app.deactivateCondensedSidebar();
					that.app.deactivateScrollableSidebar();
					break;
				case 'scrollable':
					that.app.activateScrollableSidebar();
					break;
				case 'condensed':
					that.app.activateCondensedSidebar();
					break;
			}
			that._selectOptionsFromConfig();
		});

		// overall color scheme
		$('input[type=checkbox][name=color-scheme-mode]').on('change', function() {

			switch ($(this).val()) {
				case 'light':
					that.app.deactivateDarkMode();
					$('#default-check').prop('checked', true);
					$('input[type=checkbox][name=theme]').prop('disabled', false);
					break;
				case 'dark':
					that.app.activateDarkMode();
					$('#dark-check').prop('checked', true);
					break;
			}

			that._selectOptionsFromConfig();
		});

		// reset
		$('#resetBtn').on('click', (e) => {
			e.preventDefault();
			// reset to default
			that.app.resetLayout(() => {
				that._selectOptionsFromConfig();
			});
		});
	}
}
